// extracted by mini-css-extract-plugin
export default {"base":"CRocj","topSection":"ucwKf","status":"IQUKf"};